// extracted by mini-css-extract-plugin
module.exports = {"title":"NoCompaniesPage_title__2jU7D","description":"NoCompaniesPage_description__xz9Fl"};